import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AccountPackageService } from '../service/account-package.service';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { Constants } from '../constants/constants';
import { NavigationExtras, Router } from '@angular/router';
import { ToastService } from '../service/toast.service';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { SearchDataService } from '../service/search-data.service';
import { EnvService } from '../service/env.service';

import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { BeInvoicesComponent } from '../be-invoices/be-invoices.component';

@Component({
  selector: 'app-business-entity',
  templateUrl: './business-entity.component.html',
  styleUrls: ['./business-entity.component.scss']
})
export class BusinessEntityComponent implements OnInit {

  // sortType = ["DESCENDING", "ASCENDING"];
  // columns = ["Invoice No", "Account", "Amount", "invoiceDate", "invoiceSummary.dueDate", "Status"];
  // invoiceStatusList: Array<string> = ["DRAFT", "OPEN", "PAID", "OVERDUE", "VOIDED"];
  // tableSelectedSortOptions: Array<string>;

  isViewScreen = false;
  accountCategory: string;
  businessEntities = [];
  selectedBusinessEntity = null;
  invoices = [];

  accountType: string;
  viewInvoice: boolean = false;
  selectedInvoice: any;
  invoiceId: string;

  showPaymentProfile: boolean = false;

  @ViewChild('beInvoiceListComponent', { static: true }) beInvoiceListComponent:BeInvoicesComponent;

  constructor(private accountServicePackage: AccountPackageService, public apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private router: Router, private toast: ToastService, private searchService: SearchDataService, private env: EnvService) { }

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.businessEntities = this.getBusinessEntities();
    this.invoices = this.getInvoices();
    // this.initTableSelectedSortOptions();
  }

  navigateToDetailPage(businessEntity) {
    this.isViewScreen = true;
    this.selectedBusinessEntity = businessEntity;
  }

  closeClicked() {
    this.isViewScreen = false;
    this.selectedBusinessEntity = null;
  }

  showSelectedInvoice() {
    let invoice = this.invoices.find(invoice => invoice.invoiceId === this.invoiceId);
    console.log("show selected invoice::", invoice);
    if(invoice) {
      this.beInvoiceListComponent.onInvoiceSelected(invoice);
      this.onInvoiceSelected(invoice);
    }
  }

  onInvoiceSelected(invoice) {
    this.selectedInvoice = invoice;
    this.viewInvoice = true;
  }

  onCloseInvoiceView() {
    console.log("onCloseInvoiceView");
    this.beInvoiceListComponent.onCloseInvoiceView();
    this.selectedInvoice = null;
    this.viewInvoice = false;
    this.invoices = this.getInvoices();
  }

  setShowPaymentProfile() {
    this.showPaymentProfile = this.env.SHOW_PAYMENT;
  }

  // initTableSelectedSortOptions() {
  //   this.tableSelectedSortOptions = [this.columns[3], this.sortType[0]];
  // }

  // onSortByDateClick(selectedColumn: string) {
  //   var sortType = this.getSortType(selectedColumn);
  //   console.log("sortType::", sortType);
  //   this.sortByDate(sortType, selectedColumn, this.invoices);
  //   this.tableSelectedSortOptions[0] = selectedColumn;
  //   this.tableSelectedSortOptions[1] = sortType;
  // }

  // getSortType(selectedColumn: string) {
  //   var selectedSortType = this.tableSelectedSortOptions[1];
  //   var lastSelectedSortColumn = this.tableSelectedSortOptions[0];
  //   if (lastSelectedSortColumn == selectedColumn) {
  //     if (selectedSortType == this.sortType[0]) {
  //       selectedSortType = this.sortType[1];
  //     } else {
  //       selectedSortType = this.sortType[0];
  //     }
  //   }
  //   return selectedSortType == null ? this.sortType[0] : selectedSortType;
  // }

  // sortStringVal(sortType: string, fieldName: string, invoices) {
  //   let that = this;
  //   invoices = invoices.sort(function (a, b) {
  //     var val1 = "";
  //     var val2 = "";
  //     if (a[fieldName] != undefined && a[fieldName] != null) {
  //       val1 = a[fieldName].toLowerCase();
  //     }
  //     if (b[fieldName] != undefined && b[fieldName] != null) {
  //       val2 = b[fieldName].toLowerCase();
  //     }
  //     if (sortType == that.sortType[0]) {
  //       if (val1 < val2) return -1;
  //       if (val1 > val2) return 1;
  //       return 0;
  //     } else {
  //       if (val1 > val2) return -1;
  //       if (val1 < val2) return 1;
  //       return 0;
  //     }
  //   });
  // }

  // sortByDate(sortType: string, fieldName: string, invoices) {
  //   let that = this;
  //   invoices = invoices.sort(function (a, b) {
  //     if (sortType == that.sortType[0]) {
  //       return <any>new Date(b[fieldName]) - <any>new Date(a[fieldName]);
  //     } else {
  //       return <any>new Date(a[fieldName]) - <any>new Date(b[fieldName]);
  //     }
  //   });
  // }

  getBusinessEntities() {
    return [
      {
        "id": "655f70bac79c024376567f9a",
        "accountId": "655f1db907d14f40ad9b7713",
        "oemCustomerId": "NIUSME02",
        "accountName": "Mercedes of Cool Springs",
        "appAccountType": "BUSINESS_ENTITY",
        "startDate": 1700753594683,
        "appType": "MOBILITY",
        "appId": "643e927f7c388742c2d8e594",
        "parentAccountId": "NIUSIN01",
        "associatedAccountId": [
          "NIUSNI03"
        ],
        // Below data not part of api. Added for ui.
        "paymentType": "Non-Revenue", //Revenue
        "accountBalance": "20",
        "status": "ACTIVE",
        "contactPoints": {
          "addresses": [
            {
              "street": "156 Main St",
              "city": "Middleton",
              "state": "MA",
              "stateName": "Massachusetts",
              "country": "US",
              "postalCode": "01949"
            }
          ]
        }
      }
    ];
  }

  getInvoices() {
    return [
      {
        "accountNumber": "NIUSNI00",
        "logo": "https://stg.conexio.life/assets/images/1564783530663-nissan.png",
        "customerInfo": {
          "accountInfo": {
            "name": "Mercedes of Cool Springs",
            "address": {
              "street": "1 Nissan Way",
              "city": "Franklin",
              "state": "TN",
              "stateName": "Tennessee",
              "country": "US",
              "zipCode": "37067",
              "plus4Code": "6367"
            },
            "eventAccountInfo": {
              "name": "Mercedes of Cool Springs",
              "address": {
                "street": "1 Nissan Way",
                "city": "Franklin",
                "state": "TN",
                "stateName": "Tennessee",
                "country": "US",
                "zipCode": "37067",
                "plus4Code": "6367"
              }
            }
          },
          "billingInfo": {
            "name": "Mercedes of Cool Springs",
            "address": {
              "street": "testing address 11",
              "city": "Franklin",
              "state": "TN",
              "stateName": "Tennessee",
              "country": "US",
              "zipCode": "37067"
            },
            "oemBillingCustomerNumber": "11080",
            "oemBankAchDetail": {
              "name": "J.P. Morgan Chase Bank",
              "address": {
                "street": "270 Park Avenue",
                "city": "New York",
                "state": "NY",
                "zipCode": ""
              },
              "aba": "21000021",
              "account": "323-905749",
              "swiftCode": "CHASUS33",
              "achDescription": "CID:12087 PID:VCS"
            },
            "eventAccountInfo": {
              "name": "Mercedes of Cool Springs",
              "address": {
                "street": "testing address 11",
                "city": "Franklin",
                "state": "TN",
                "stateName": "Tennessee",
                "country": "US",
                "zipCode": "37067"
              },
              "oemBillingCustomerNumber": "11080",
              "oemBankAchDetail": {
                "name": "J.P. Morgan Chase Bank",
                "address": {
                  "street": "270 Park Avenue",
                  "city": "New York",
                  "state": "NY",
                  "zipCode": ""
                },
                "aba": "21000021",
                "account": "323-905749",
                "swiftCode": "CHASUS33",
                "achDescription": "CID:12087 PID:VCS"
              }
            }
          }
        },
        "invoiceId": "624aed52549c2f6ee0c952e8",
        "invoiceNumber": "NISNIS0000141",
        "invoiceDate": 1649077586309,
        "invoiceStatus": "PAID",
        "paymentStatus": "SUCCESSFUL",
        "invoiceSummary": {
          "dueDate": 1650931199999,
          "paymentTerm": 21,
          "currency": "USD",
          "subTotal": 1,
          "discounts": 0,
          "credits": 0,
          "taxes": 0.09,
          "total": 1.09,
          "items": [
            {
              "type": "SERVICE_PACKAGE",
              "id": "6246e50707d14f52bfcb2a80",
              "name": "Test package 89347"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "624620be07d14f52bfcb289d",
              "name": "Package_20220331_3"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "6246be4307d14f52bfcb298c",
              "name": "Package_20220401_1"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "5d45d0ef07d14f548aeee978",
              "name": "Remote Ops Fleet"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "623ab11d07d14f04a6fa684b",
              "name": "Package20220323_1"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "5d45d1ae07d14f548aeee97a",
              "name": "Remote Monitor Fleet"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "6246e66e07d14f52bfcb2b7f",
              "name": "Package_20220401_11"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "5d45d15e07d14f548aeee979",
              "name": "Journey Data Fleet"
            }
          ],
          "billingPeriod": {
            "startDate": 1646092800000,
            "endDate": 1648771199999
          },
          "billingCycle": "MONTHLY"
        },
        "invoiceBreakdown": [
          {
            "type": "SERVICE_PACKAGE",
            "id": "6246e50707d14f52bfcb2a80",
            "name": "Test package 89347",
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0.0975,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "DEFAULT_SERVICE_RATES",
            "appliedAs": "TRIAL",
            "vehicleCount": 0,
            "serviceLineItems": []
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "624620be07d14f52bfcb289d",
            "name": "Package_20220331_3",
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0.0975,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "DEFAULT_SERVICE_RATES_OVERAGE_PRICING",
            "appliedAs": "TRIAL",
            "vehicleCount": 0,
            "serviceLineItems": []
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "6246be4307d14f52bfcb298c",
            "name": "Package_20220401_1",
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "DEFAULT_SERVICE_RATES",
            "appliedAs": "TRIAL",
            "vehicleCount": 0,
            "serviceLineItems": []
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "5d45d0ef07d14f548aeee978",
            "name": "Remote Ops Fleet",
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0.0975,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "DEFAULT_SERVICE_RATES",
            "appliedAs": "PREMIUM",
            "vehicleCount": 3,
            "serviceLineItems": [
              {
                "type": "SERVICE",
                "id": "5d45bae607d14f548aeee959",
                "name": "Remote Door Lock / Unlock",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              },
              {
                "type": "SERVICE",
                "id": "5d45bb8807d14f548aeee95e",
                "name": "Location",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              },
              {
                "type": "SERVICE",
                "id": "5d45bb3807d14f548aeee95c",
                "name": "Remote Horn & Light",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              },
              {
                "type": "SERVICE",
                "id": "5d45bb5607d14f548aeee95d",
                "name": "Remote Engine Start / Stop",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              }
            ],
            "attributes": [
              {
                "name": "oemPackageType",
                "value": "Remote Services"
              },
              {
                "name": "oemPackageCode",
                "value": "NCC001"
              }
            ]
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "623ab11d07d14f04a6fa684b",
            "name": "Package20220323_1",
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0.0975,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "DEFAULT_SERVICE_RATES",
            "appliedAs": "PREMIUM",
            "vehicleCount": 0,
            "serviceLineItems": [
              {
                "type": "SERVICE",
                "id": "5d45bb8807d14f548aeee95e",
                "name": "Location",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              },
              {
                "type": "SERVICE",
                "id": "5d45bb3807d14f548aeee95c",
                "name": "Remote Horn & Light",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              }
            ]
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "5d45d1ae07d14f548aeee97a",
            "name": "Remote Monitor Fleet",
            "units": 0,
            "rate": 10,
            "discounts": 0,
            "subTotal": 1,
            "taxRates": 0.0097,
            "taxes": 0.09,
            "total": 1.09,
            "ratePlanType": "FLAT_RATE",
            "usageType": "OVERAGE_CHARGING",
            "appliedAs": "PREMIUM",
            "vehicleCount": 2,
            "serviceLineItems": [
              {
                "type": "SERVICE",
                "id": "5d45bba407d14f548aeee95f",
                "name": "Geofence Monitoring"
              },
              {
                "type": "SERVICE",
                "id": "5d45bbe107d14f548aeee961",
                "name": "Speed Alert Monitoring"
              },
              {
                "type": "SERVICE",
                "id": "5d45bbca07d14f548aeee960",
                "name": "Curfew Alert Monitoring"
              }
            ],
            "attributes": [
              {
                "name": "oemPackageType",
                "value": "Telemetry Data"
              },
              {
                "name": "oemPackageCode",
                "value": "NCC002"
              }
            ]
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "6246e66e07d14f52bfcb2b7f",
            "name": "Package_20220401_11",
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "DEFAULT_SERVICE_RATES",
            "appliedAs": "TRIAL",
            "vehicleCount": 0,
            "serviceLineItems": []
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "5d45d15e07d14f548aeee979",
            "name": "Journey Data Fleet",
            "units": 2,
            "rate": 0,
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0.0975,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "LICENSE_BASED",
            "usageType": "UNLIMITED_USAGE",
            "appliedAs": "PREMIUM",
            "vehicleCount": 2,
            "serviceLineItems": [
              {
                "type": "SERVICE",
                "id": "5d45c09507d14f548aeee965",
                "name": "Journey Probe Complete"
              }
            ],
            "attributes": [
              {
                "name": "oemPackageType",
                "value": "Telemetry Data"
              },
              {
                "name": "oemPackageCode",
                "value": "NCC001"
              }
            ]
          }
        ],
        "accountId": "5c992c5307d14f083ac8e721",
        "oemId": "5c80ddfb07d14f229f0db62f",
        "billingState": "INVOICE_GENERATED"
      },
      {
        "accountNumber": "NIUSNI00",
        "logo": "https://stg.conexio.life/assets/images/1564783530663-nissan.png",
        "customerInfo": {
          "accountInfo": {
            "name": "Mercedes of Cool Springs",
            "address": {
              "street": "1 Nissan Way",
              "city": "Franklin",
              "state": "TN",
              "stateName": "Tennessee",
              "country": "US",
              "zipCode": "37067",
              "plus4Code": "6367"
            },
            "eventAccountInfo": {
              "name": "Mercedes of Cool Springs",
              "address": {
                "street": "1 Nissan Way",
                "city": "Franklin",
                "state": "TN",
                "stateName": "Tennessee",
                "country": "US",
                "zipCode": "37067",
                "plus4Code": "6367"
              }
            }
          },
          "billingInfo": {
            "name": "Mercedes of Cool Springs",
            "address": {
              "street": "testing address 11",
              "city": "Franklin",
              "state": "TN",
              "stateName": "Tennessee",
              "country": "US",
              "zipCode": "37067"
            },
            "oemBillingCustomerNumber": "11080",
            "oemBankAchDetail": {
              "name": "J.P. Morgan Chase Bank",
              "address": {
                "street": "270 Park Avenue",
                "city": "New York",
                "state": "NY",
                "zipCode": ""
              },
              "aba": "21000021",
              "account": "323-905749",
              "swiftCode": "CHASUS33",
              "achDescription": "CID:12087 PID:VCS"
            },
            "eventAccountInfo": {
              "name": "Mercedes of Cool Springs",
              "address": {
                "street": "testing address 11",
                "city": "Franklin",
                "state": "TN",
                "stateName": "Tennessee",
                "country": "US",
                "zipCode": "37067"
              },
              "oemBillingCustomerNumber": "11080",
              "oemBankAchDetail": {
                "name": "J.P. Morgan Chase Bank",
                "address": {
                  "street": "270 Park Avenue",
                  "city": "New York",
                  "state": "NY",
                  "zipCode": ""
                },
                "aba": "21000021",
                "account": "323-905749",
                "swiftCode": "CHASUS33",
                "achDescription": "CID:12087 PID:VCS"
              }
            }
          }
        },
        "invoiceId": "622231f3549c2f4a668d5ccd",
        "invoiceNumber": "NISNIS0000138",
        "invoiceDate": 1646408179405,
        "invoiceStatus": "PAID",
        "invoiceSummary": {
          "dueDate": 1648252799999,
          "paymentTerm": 21,
          "currency": "USD",
          "subTotal": 60,
          "discounts": 0,
          "credits": 0,
          "taxes": 0.98,
          "total": 60.98,
          "items": [
            {
              "type": "SERVICE_PACKAGE",
              "id": "61dec62207d14f4dcac3b6f5",
              "name": "Test Default Package 2 Updated"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "5d45d0ef07d14f548aeee978",
              "name": "Remote Ops Fleet"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "5d45d1ae07d14f548aeee97a",
              "name": "Remote Monitor Fleet"
            },
            {
              "type": "SERVICE_PACKAGE",
              "id": "5d45d15e07d14f548aeee979",
              "name": "Journey Data Fleet"
            }
          ],
          "billingPeriod": {
            "startDate": 1643673600000,
            "endDate": 1646092799999
          },
          "billingCycle": "MONTHLY"
        },
        "invoiceBreakdown": [
          {
            "type": "SERVICE_PACKAGE",
            "id": "61dec62207d14f4dcac3b6f5",
            "name": "Test Default Package 2 Updated",
            "units": 0,
            "rate": 50,
            "discounts": 0,
            "subTotal": 50,
            "taxRates": 0,
            "taxes": 0,
            "total": 50,
            "ratePlanType": "FLAT_RATE",
            "usageType": "UNLIMITED_USAGE",
            "appliedAs": "PREMIUM",
            "vehicleCount": 0,
            "serviceLineItems": [
              {
                "type": "SERVICE",
                "id": "5d45bba407d14f548aeee95f",
                "name": "Geofence Monitoring"
              },
              {
                "type": "SERVICE",
                "id": "5d45bb8807d14f548aeee95e",
                "name": "Location"
              },
              {
                "type": "SERVICE",
                "id": "5d45bb5607d14f548aeee95d",
                "name": "Remote Engine Start / Stop"
              }
            ],
            "attributes": [
              {
                "name": "oemPackageType",
                "value": "Telemetry Data"
              },
              {
                "name": "oemPackageCode",
                "value": "NCC002"
              }
            ]
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "5d45d0ef07d14f548aeee978",
            "name": "Remote Ops Fleet",
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0.0975,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "DEFAULT_SERVICE_RATES",
            "appliedAs": "PREMIUM",
            "vehicleCount": 3,
            "serviceLineItems": [
              {
                "type": "SERVICE",
                "id": "5d45bae607d14f548aeee959",
                "name": "Remote Door Lock / Unlock",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              },
              {
                "type": "SERVICE",
                "id": "5d45bb8807d14f548aeee95e",
                "name": "Location",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              },
              {
                "type": "SERVICE",
                "id": "5d45bb3807d14f548aeee95c",
                "name": "Remote Horn & Light",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              },
              {
                "type": "SERVICE",
                "id": "5d45bb5607d14f548aeee95d",
                "name": "Remote Engine Start / Stop",
                "units": 0,
                "rate": 0.15,
                "discounts": 0,
                "subTotal": 0,
                "taxRates": 0.0975,
                "taxes": 0,
                "total": 0
              }
            ],
            "attributes": [
              {
                "name": "oemPackageType",
                "value": "Remote Services"
              },
              {
                "name": "oemPackageCode",
                "value": "NCC001"
              }
            ]
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "5d45d1ae07d14f548aeee97a",
            "name": "Remote Monitor Fleet",
            "units": 0,
            "rate": 10,
            "discounts": 0,
            "subTotal": 10,
            "taxRates": 0.0975,
            "taxes": 0.98,
            "total": 10.98,
            "ratePlanType": "FLAT_RATE",
            "usageType": "OVERAGE_CHARGING",
            "appliedAs": "PREMIUM",
            "vehicleCount": 2,
            "serviceLineItems": [
              {
                "type": "SERVICE",
                "id": "5d45bba407d14f548aeee95f",
                "name": "Geofence Monitoring"
              },
              {
                "type": "SERVICE",
                "id": "5d45bbe107d14f548aeee961",
                "name": "Speed Alert Monitoring"
              },
              {
                "type": "SERVICE",
                "id": "5d45bbca07d14f548aeee960",
                "name": "Curfew Alert Monitoring"
              }
            ],
            "attributes": [
              {
                "name": "oemPackageType",
                "value": "Telemetry Data"
              },
              {
                "name": "oemPackageCode",
                "value": "NCC002"
              }
            ]
          },
          {
            "type": "SERVICE_PACKAGE",
            "id": "5d45d15e07d14f548aeee979",
            "name": "Journey Data Fleet",
            "units": 2,
            "rate": 0,
            "discounts": 0,
            "subTotal": 0,
            "taxRates": 0.0975,
            "taxes": 0,
            "total": 0,
            "ratePlanType": "LICENSE_BASED",
            "usageType": "UNLIMITED_USAGE",
            "appliedAs": "PREMIUM",
            "vehicleCount": 2,
            "serviceLineItems": [
              {
                "type": "SERVICE",
                "id": "5d45c09507d14f548aeee965",
                "name": "Journey Probe Complete"
              }
            ],
            "attributes": [
              {
                "name": "oemPackageType",
                "value": "Telemetry Data"
              },
              {
                "name": "oemPackageCode",
                "value": "NCC001"
              }
            ]
          }
        ],
        "accountId": "5c992c5307d14f083ac8e721",
        "oemId": "5c80ddfb07d14f229f0db62f",
        "billingState": "INVOICE_GENERATED"
      }
    ];
  }
}
